/* eslint-disable @typescript-eslint/ban-ts-comment */

import React from 'react'
import { Center, Text, csx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { QRCodeCanvas } from 'qrcode.react'

import { DrawerBody, DrawerTitle } from '../../../../../../ui/components'
import { useTransfer } from '../../../../../../core/globalState/transfer'
import { useOrderForm } from '../../../../../../core/requests/checkout'

export const TransferCartContent = () => {
  const { transfer } = useTransfer()
  const { orderForm } = useOrderForm()

  return (
    <>
      <DrawerTitle>
        <FormattedMessage id="checkout.options-drawer.transfer.title" />
      </DrawerTitle>
      <DrawerBody>
        <Text>
          <FormattedMessage id="checkout.options-drawer.transfer.message" />
        </Text>
        <Center
          className={csx({
            marginTop: '$space-4',
            padding: '$space-4',
            borderRadius: 'default',
            background: '$secondary',
          })}
        >
          <QRCodeCanvas
            data-testid="transfer-cart-content-qrcode"
            // TODO: this error popped up when moving the checkout-instore project
            // to checkout-instore-legacy, but needs to be fixed at some point
            // @ts-ignore
            value={orderForm?.orderFormId}
          />
        </Center>
        <div
          className={csx({
            border: '$neutral',
            borderRadius: 'default',
            padding: '$space-3',
            marginTop: '$space-2',
            wordWrap: 'break-word',
            textAlign: 'center',
          })}
        >
          <Text
            variant="display"
            tone="info"
            className={csx({ color: '$blue40' })}
          >
            {transfer.code}
          </Text>
        </div>
      </DrawerBody>
    </>
  )
}
